import { useApplicationSummary } from 'hooks/useApplicationSummary';
import { useCalculatorContext } from './CalculatorContext';
import Button from 'components/atoms/Button/Button';
import useClientOffer from 'hooks/useClientOffer';

export const SubmitButton = ({ className }: { className?: string }) => {
  const {
    onSubmit,
    isLoading,
    setIsLoading,
    days,
    amount,
    content: { confirmChanges },
  } = useCalculatorContext();
  const { amount: amountSummary, term: termSummary } = useApplicationSummary();
  const { fetch: fetchClientOffer } = useClientOffer();

  const handleSubmit: React.MouseEventHandler<HTMLButtonElement> = async (
    event,
  ) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      await onSubmit?.({ amount, days });
      // For ATs - Extra call to force calculator update values for corner cases
      if (amountSummary !== amount || termSummary !== days) {
        await fetchClientOffer({
          queryParameters: {
            amount: amount,
            term: days,
          },
        });
      }
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className={className}
      onClick={handleSubmit}
      fill
      loading={isLoading || days === undefined || amount === undefined}
      dataTest="calculator-button-submit"
    >
      {confirmChanges}
    </Button>
  );
};
